import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// MAT_DATE_LOCALE (ci-dessous) ne couvre que le datepicker Material. Sans ça, les pipes
// natifs Angular (currency, date, number) restaient en anglo-américain par défaut :
// "€100.00" au lieu de "100,00 €". LOCALE_ID + registerLocaleData couvrent ces pipes.
registerLocaleData(localeFr, 'fr-FR');

import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ClientContextInterceptor } from './interceptors/client-context.interceptor';

// Core components (loaded immediately)
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { PreferencesBottomSheetComponent } from './home/preferences-bottom-sheet/preferences-bottom-sheet.component';
import { AdhesionComponent } from './adhesion/adhesion.component';
import { NavbarComponent, IosSnackBarAnnotatedComponent } from './navbar/navbar.component';
import { PointsHelpDialogComponent } from './navbar/points-help-dialog/points-help-dialog.component';
import { NewsTickerComponent } from './navbar/news-ticker/news-ticker.component';
import { BottomNavComponent } from './shared/bottom-nav/bottom-nav.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    PreferencesBottomSheetComponent,
    AdhesionComponent,
    NavbarComponent,
    IosSnackBarAnnotatedComponent,
    PointsHelpDialogComponent,
    NewsTickerComponent,
    BottomNavComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ServiceWorkerModule.register('custom-service-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ClientContextInterceptor, multi: true },
    // Material's default dialog scroll strategy ("block") freezes the
    // background page by pinning <html> to position:fixed with a negative
    // top offset computed from the current scroll position. On iOS Safari
    // this offset can be captured while the page is still mid-scroll
    // (elastic overscroll settling), which throws off the dialog's own
    // fixed positioning — worse the further the page had scrolled — leaving
    // it rendered partly or fully below the visible viewport with no way to
    // reach the action buttons. "reposition" avoids the freeze hack
    // entirely and just re-centers the dialog on scroll instead.
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.reposition(),
      deps: [Overlay],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
